<template>
  <v-card class="pb-10 pt-5">
    <v-row align="center" justify="center">
      <v-col cols="12" md="6" class="text-center">
        <div class="error_code">
          <h1 class="text-center">{{ code }}</h1>
        </div>
        <div>
          <h3 class="text-center error-message mb-10">
            {{ displayMessage }}
          </h3>
          <v-btn @click="goHome()" color="#7f1416" dark>
            {{ $t('Back to Home') }} </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<style>
.page_404 {
  padding: 40px 0;
  background: #fff;
}

.page_404 img {
  width: 100%;
}

.error_code {
  background-image: url(https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif);
  height: 400px;
  background-position: center;
}

.error-message {
  font-size: 24px;
  color: #555;
  margin-top: 20px;
  margin: 20px 20px;
  border-left: #555 5px solid;
  border-right: #555 5px solid;
  padding: 10px;
  border-radius: 10px;
  background-color: #f8f8f8;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

h1 {
  font-size: 80px;
}
</style>

<script>
import { StatusCodeMessages } from '@/common/RESPONSE_CODE_MESSAGES';

export default {
  computed: {
    code() {
      const rawCode = parseInt(this.$route.params.code, 10);
      return StatusCodeMessages[rawCode] ? rawCode : 404;
    },
    displayMessage() {
      return this.$route.query.message || StatusCodeMessages[this.code];
    },
  },
  methods: {
    goHome() {
      this.$router.push({ name: 'Home' });
    },
  },
};
</script>